import { put, takeLatest } from 'redux-saga/effects'
import { submitPasswordResetConfirmation as submit } from '../api/submitPasswordResetConfirmation'
import {
  submitPasswordResetConfirmationSucceeded,
  submitPasswordResetConfirmationFailed
} from '../../actions/passwordResetConfirmation'
import { SUBMIT_PASSWORD_RESET_CONFIRMATION } from '../../constants/action.types'
import executeSaga from './helpers/executeSaga'

export function* submitPasswordChange({ request }, action) {
  const {
    password,
    passwordConfirmation,
    token,
    recaptchaResponse
  } = action.payload
  const data = {
    user_password: password,
    user_password_confirmation: passwordConfirmation,
    'g-recaptcha-response': recaptchaResponse,
    token: token
  }

  yield executeSaga(
    request,
    data,
    () => put(submitPasswordResetConfirmationSucceeded()),
    error =>
      put(submitPasswordResetConfirmationFailed({ error: error.message }))
  )
}

export default function*({ request } = { request: submit }) {
  yield takeLatest(SUBMIT_PASSWORD_RESET_CONFIRMATION, submitPasswordChange, {
    request
  })
}
